export default __webpack_public_path__ + "static/media/IMG-20241210-WA0039.8864cb3c.jpg";